import { TipTierEnum } from 'src/app/services/interest/Location/location-service.type';
import { EnterpriseRelationsResultType } from 'src/types/enterprise.type';
import { LocationsColumnDataType } from 'src/types/table.type';

export type PropsType = {
  isSupplyChainMap?: boolean;
  isEnterprise?: boolean;
  isExportMap: boolean;
  // countries: [];
  // allSupplierCompanies?: SupplierEnterprisesResultType[];
  allSupplierCompanies?: EnterpriseRelationsResultType['from']['rows'];
  generalAllData: LocationsColumnDataType[];
};

export type SortTypeOptions = 'prevalence' | 'modernSlavery' | 'tier' | 'government';

export const convertTiersToIntegers = (tier: string | undefined) => {
  switch (tier) {
    case 'Tier 1':
      return 0;

    case 'Tier 2':
      return 1;

    case 'Tier 2 Watch List':
      return 2;

    case 'Tier 3':
      return 3;

    case 'Special Case':
      return 4;

    // case 'N/A':
    //   return 5;

    case 'No Data':
      return 5;

    default:
      return 10;
  }
};
export const governmentResponseToRating = (governmentResponse: number | undefined) => {
  switch (governmentResponse) {
    case null:
      return NaN;

    default:
      return governmentResponse;
  }
};
export const handleRankingsBySort = (sortByValue: SortTypeOptions, locationList: LocationsColumnDataType[]) => {
  let outputArray: Record<string, number> = {};
  try {
    switch (sortByValue) {
      case 'prevalence':
        locationList.forEach((eachCountry: any) => {
          if (eachCountry.prevalenceIndexRank) {
            outputArray = {
              ...outputArray,
              [eachCountry.alphaCode]: eachCountry.prevalenceIndexRank,
            };
          }
        });
        break;
      case 'tier':
        locationList.forEach((eachCountry) => {
          if (eachCountry.tier) {
            outputArray = {
              ...outputArray,
              [eachCountry.alphaCode]: TipTierEnum[eachCountry.tier.replaceAll(' ', '_') as keyof typeof TipTierEnum],
            };
          }
        });
        break;
      case 'government':
        locationList.forEach((eachCountry: any) => {
          if (eachCountry.governmentResponse) {
            outputArray = {
              ...outputArray,
              [eachCountry.alphaCode]: governmentResponseToRating(eachCountry.governmentResponse),
            };
          }
        });
        break;

      default:
        locationList.forEach((eachCountry: any) => {
          if (eachCountry.modernSlaveryScore) {
            outputArray = {
              ...outputArray,
              [eachCountry.alphaCode]: eachCountry.modernSlaveryScore,
            };
          }
        });
        break;
    }
    return outputArray;
  } catch (error) {
    console.log('error :>> ', error);
  }
};
